import { Component, OnInit } from '@angular/core';
import { SuiModalService } from '@richardlt/ng2-semantic-ui';

@Component({
	selector: 'app-award-agent-detail',
	templateUrl: './award-detail.component.html',
	styleUrls: [ './award-detail.component.scss' ]
})
export class AwardAgentDetailComponent implements OnInit {
	editLot() {
		// this.modalService
		// 	.open(new LotEditModal('Edit Lot', 'Are you sure you want to delete this Lot plan?', ModalSize.Tiny))
		// 	.onApprove(() => {})
		// 	.onDeny(() => {});
	}

	viewProject() {
		// this.modalService
		// 	.open(new ViewProjectModal('Edit Lot', 'Are you sure you want to delete this Lot plan?', ModalSize.Tiny))
		// 	.onApprove(() => {})
		// 	.onDeny(() => {});
	}

	constructor(private modalService: SuiModalService) {}

	ngOnInit(): void {}
}
